import { get, find, concat, map, toUpper } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { getModels } from "resources/models"
import { filterATForecasts } from "resources/forecasts"
import { getSwapsWithMeta } from "./swaps"
import { getWatchlistsWithMeta } from "./watchlists"
import { getTopicsWithMeta } from "./topics"
import { getPortfoliosWithMeta } from "./portfolios"

const EMPTY_ARRAY = []

const getRawSelectedModel = state => get(state, "modules.resources.selectedModel")
export const getFavoritesScreen = (_, props) => get(props, "favorites", null)
const getForecasts = state => get(state, "global.data.forecasts.data.forecasts")

const getRawRecentResources = state => get(state, "modules.resources.recentResources", EMPTY_ARRAY)

export const getResources = createSelector(
  [getSwapsWithMeta, getTopicsWithMeta, getWatchlistsWithMeta, getPortfoliosWithMeta],
  (swaps, topics, watchlists, portfolios) => concat(swaps, topics, watchlists, portfolios),
)

export const getRecentResources = createSelector(
  [getRawRecentResources, getResources],
  (recentResources, resources) => map(recentResources, resource => find(resources, ({ id, alias }) => resource.type === "swap" ? toUpper(resource.alias) === toUpper(alias) : resource.id === id)),
)

const getMostUsedModelOrDefault = createSelector(
  [getPortfoliosWithMeta, getModels],
  getMostUsedOrDefaultModelId,
)

export const getModel = createSelector(
  [getMostUsedModelOrDefault, getRawSelectedModel],
  (mostUsedModelOrDefault, selectedModel) => selectedModel || mostUsedModelOrDefault,
)

export const getATForecasts = createSelector(
  [getForecasts],
  filterATForecasts,
)
